import { getIdNamePairsFromEnum } from "@/methods/utils";
import { InstituteTestStatusEnum } from "@/enums/createTest";
import { AssignmentStatusEnum } from "@/enums/createAssignment";
import { LiveClassCategoryEnum } from "@/enums/liveClass";
import {
  ValidTutorSessionCategoryEnum,
  TutorSessionCategoryEnum,
  DemoSessionStatusIdEnum,
} from "@/enums/tutoring";

export const AllStoreSettings = Object.freeze({
  manageInstituteTest: {
    CategoryRadioButtons: getIdNamePairsFromEnum(InstituteTestStatusEnum),
    FilterFields: ["Course", "Subjects", "Batches"],
    SearchFields: ["TestName", "Course", "Batches", "CreatedBy", "UpdatedBy"],
    UiPageSize: 10,
    ApiPageSize: 200,
    EnableDownload: false,
    DownloadItems: null,
  },
  manageAssignment: {
    CategoryRadioButtons: getIdNamePairsFromEnum(AssignmentStatusEnum),
    FilterFields: ["Course", "Subjects", "Batches"],
    SearchFields: ["AssignmentName", "Course", "CreatedBy", "UpdatedBy"],
    UiPageSize: 10,
    ApiPageSize: 200,
    EnableDownload: false,
    DownloadItems: null,
  },
  manageAffiliation: {
    CategoryRadioButtons: null,
    FilterFields: ["Affiliation"],
    SearchFields: null,
    UiPageSize: 10,
    ApiPageSize: 200,
    EnableDownload: false,
    DownloadItems: null,
  },
  tutoringStudentDashboard: {
    CategoryRadioButtons: [],
    FilterFields: ["Course"],
    SearchFields: ["SessionTitle", "Course"],
    UiPageSize: 10,
    ApiPageSize: 200,
    EnableDownload: false,
    DownloadItems: null,
  },
  manageLiveClass: {
    CategoryRadioButtons: getIdNamePairsFromEnum(LiveClassCategoryEnum),
    FilterFields: ["Batches", "Subject", "Faculty"],
    SearchFields: ["LiveClassName", "Subject", "Faculty"],
    UiPageSize: 10,
    ApiPageSize: 200,
    EnableDownload: true,
    CardsDownloadItems: [
      "LiveClassName",
      "Faculty.Name",
      "Subject.Name",
      "StartDatetime",
      "Duration",
      "MeetingAttendeeUrl",
      "OwnerEmailId",
    ],
  },
  offlineTestSubjectWiseReport: {
    CategoryRadioButtons: null,
    FilterFields: ["Affiliation", "Batch"],
    SearchFields: ["Affiliation", "Batch", "TestName"],
    UiPageSize: 10,
    ApiPageSize: 200,
    EnableDownload: false,
    DownloadItems: null,
  },
  manageQrCodes: {
    CategoryRadioButtons: null,
    FilterFields: ["QrCategory", "Content"],
    SearchFields: [
      "QrCategory",
      "QrTitle",
      "QrDescription",
      "AdditionalInfo",
      "QrTarget",
      "Content",
    ],
    UiPageSize: 10,
    ApiPageSize: 200,
    EnableDownload: false,
    DownloadItems: null,
  },
  tutoringTutorDashboard: {
    CategoryRadioButtons: getIdNamePairsFromEnum(ValidTutorSessionCategoryEnum),
    FilterFields: ["Student", "Course"],
    SearchFields: ["SessionTitle", "Course", "Student"],
    UiPageSize: 10,
    ApiPageSize: 50,
    EnableDownload: false,
    DownloadItems: null,
  },
  tutoringAdminDemoSessions: {
    CategoryRadioButtons: getIdNamePairsFromEnum(DemoSessionStatusIdEnum),
    FilterFields: ["Student", "Tutor", "Course"],
    SearchFields: ["SessionTitle", "Student", "Tutor", "Course"],
    UiPageSize: 10,
    ApiPageSize: 500,
    EnableDownload: false,
    DownloadItems: null,
  },
  tutoringAdminPaidSessions: {
    CategoryRadioButtons: getIdNamePairsFromEnum(TutorSessionCategoryEnum),
    FilterFields: ["Student", "Tutor", "Course"],
    SearchFields: ["SessionTitle", "Student", "Tutor", "Course"],
    UiPageSize: 10,
    ApiPageSize: 500,
    EnableDownload: false,
    DownloadItems: null,
  },
});
